<template>
  <el-container class="selectObject">
    <!-- 单位信息 -->
    <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree
          ref="treeRef"
          :data="dataSource"
          node-key="deptId"
          highlight-current
          :props="{ label: 'name' }"
          :default-expanded-keys="[rootNodeKey]"
          @current-change="currentChange"
          :expand-on-click-node="true"
          :filter-node-method="filterNode"
        >
        </el-tree>
      </div>
    </el-card>
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <!-- <el-form-item label="" prop="">
          <el-checkbox
            v-model="checked1"
            label="全选系统"
            size="large"
          ></el-checkbox>
        </el-form-item> -->
        <el-form-item label="姓名" prop="name">
          <el-input
            v-model="tableParams.name"
            placeholder="姓名"
            @keyup.enter="refreshTable"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="queryUserList"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #zp="{ row }">
            {{ row.zp || "暂无" }}
          </template>
          <template #unitName="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.name }}</span>
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <el-dialog
      v-model="formVisible"
      :title="
        '人口' +
        (formStatus === 1 ? '新增' : formStatus === 2 ? '编辑' : '详情')
      "
      width="43%"
      height="40%"
    >
      <personnel-detail
        v-if="formVisible"
        v-model="formVisible"
        :form="userFormData"
        :status="formStatus"
        @submit="userSubmit"
      ></personnel-detail>
    </el-dialog>
  </el-container>
  <div style="text-align: center; margin-top: 20px">
    <h-button type="primary" @click="determine()">确定</h-button>
    <h-button @click="cancel">取消</h-button>
  </div>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { queryUserList } from "@/api/realPopulation/realPopulation";
import { ElMessageBox } from "element-plus";
import { getMenutree } from "@/api/system/region.js";
import _ from "lodash";
export default defineComponent({
  name: "selectObject",
  components: {},
  props: {},
  setup(props, context) {
    const state = reactive({
      filterText: "",
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      tableParams: {
        regionId: "",
        name: "",
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      columns: [
        { type: "selection" },
        {
          label: "姓名",
          hidden: true,
          slot: "unitName",
          // prop: "name"
        },
        {
          label: "性别",
          prop: "sexDict", // sex
        },
        {
          label: "证件号码",
          prop: "cardNumber",
        },
        {
          label: "民族",
          prop: "nationDict", // nation
        },
        {
          label: "居住地址",
          prop: "registerDetail",
        },
        {
          label: "电话",
          prop: "telphone",
        },
      ],
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.regionId = item.id;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const params = {
        type: "1",
      };
      const result = await getMenutree(params);
      const treeData = [result.data];
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.id;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
      }
    };
    queryOrganTreAsync();
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该用户吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {},
          () => {}
        );
      }
    };
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    const clickTable = async (item) => {
      state.userFormData = _.cloneDeep(item);
      state.formStatus = 3;
      state.formVisible = true;
    };
    const cancel = () => {
      context.emit("cancel");
    };
    const determine = () => {
      context.emit("tableSelectionObj", state.tableSelection);
    };
    return {
      ...refData,
      cancel,
      determine,
      clickTable,
      filterNode,
      currentChange,
      refreshTable,
      resetForm,
      hzTableSelect,
      handleClick,
      userSubmit,
      queryUserList,
      formRef,
      tableRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.selectObject {
  height: 500px;
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      .table-role {
        color: #294a7c;
        cursor: pointer;

        text-align: center;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
